import ContractorSearch from '../../2compounds/ContractorSearch'
import FormTextField from '../../2compounds/FormTextField'
import {validateOrganizationName} from '../../../services/util/editChecks'
import {useEffect, useState} from 'react'
import {Text} from '../../1elements'
import AddIcon from '@mui/icons-material/Add'
import SearchIcon from '@mui/icons-material/Search';

const OrganizationField = ({organization, setOrganization, organizationName, setOrganizationName, showError, disabled}) => {
    const [isSearch, setIsSearch] = useState(true)
    const switchFieldToSearch = () => {
        setOrganizationName('')
        setIsSearch(true)
    }
    const switchFieldToManual = () => {
        setOrganization('')
        setIsSearch(false)
    }

    useEffect(()=>{
        if(organization||organizationName){
            if(organization&&!organizationName){
                setIsSearch(true)
            }else{
                setIsSearch(false)
            }
        }
    }, [organization, organizationName])

    return(
        <>
            {
                isSearch ? (
                    <div>
                        <ContractorSearch value={organization}
                                          setValue={setOrganization}
                                          disabled={disabled}
                                          validation={validateOrganizationName(organization)} showError={showError}/>
                        <div onClick={switchFieldToManual}>
                            <Text type={'addBuildingNameCta'}><AddIcon /> Add a new organization</Text>
                        </div>
                    </div>
                ) : (
                    <div>
                        <FormTextField label={'Organization'} value={organizationName} onChange={setOrganizationName}
                                       validation={showError&&validateOrganizationName(organizationName)}
                                       disabled={disabled} required/>
                        <div onClick={switchFieldToSearch}>
                            <Text type={'addBuildingNameCta'}><SearchIcon /> Search an existing organization</Text>
                        </div>
                    </div>
                )
            }
        </>
    )
}

export default OrganizationField
